module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-1.0773aee8.jpg";